import {RaceEnum, LevelEnum} from '@/types/nftAttribute'
import {NFT_COUNT_MAP} from '@/types/constants'

export type raceDataType = {
  [key in RaceEnum]: {
    name: string
    count: {[key in LevelEnum]: number}
    img: {
      [key in LevelEnum]: string
    }
    desc: string
    link?: string
    bornData: {
      name: string
      img: string
      desc: string
      foodList: string[]
    }
  }
}
export const RACE_DATA: raceDataType = {
  [RaceEnum.Cyborg]: {
    name: 'Cyborg',
    count: NFT_COUNT_MAP,
    desc: 'There are few purely human beings. Every human has been mechanically transformed. But they still retain some of the knowledge and social constructs of humans, while spending their days in a survival mode against hostile species, especially AI.',
    img: {
      [LevelEnum.Legendary]:
        '/static/images/mintPage/icon/icons/race/Legendary/Cyborg.png',
      [LevelEnum.Magic]: '/static/images/mintPage/icon/icons/race/Magic/Cyborg.png',
      [LevelEnum.Common]:
        '/static/images/mintPage/icon/icons/race/PrimeEdition/Cyborg.png',
    },
    link: 'https://phala-nft-app.netlify.app/',
    bornData: {
      name: 'Test tube baby',
      desc: 'Cyborgs begin life in a test tube. They are grown rapidly to maturity through a highly accelerated process which combines the administration of mechanical implants alongside a 100% pure oxygen environment to supercharge biocellular activity.',
      img: '/static/images/detailPage/mintDetail/born-egg.png',
      foodList: ['Oxygen'],
    },
  },
  [RaceEnum.Pandroid]: {
    name: 'Pandroid',
    count: NFT_COUNT_MAP,
    desc: 'Robots are awakened consciousness. During the "Robot Independent Revolution", robots gained racial independence and sovereignty through strikes and other means.',
    img: {
      [LevelEnum.Legendary]:
        '/static/images/mintPage/icon/icons/race/Legendary/Pandorid.png',
      [LevelEnum.Magic]: '/static/images/mintPage/icon/icons/race/Magic/Pandorid.png',
      [LevelEnum.Common]:
        '/static/images/mintPage/icon/icons/race/PrimeEdition/Pandorid.png',
    },
    link: 'https://phala-nft-app.netlify.app/',
    bornData: {
      name: 'Engine',
      desc: 'Pandroids spark into existence as a basic engine lacking any specific form or function. Provided sufficient mechanical components of differing specifications they can quickly assemble themselves into a fully functioning droid.',
      img: '/static/images/detailPage/mintDetail/born-egg.png',
      foodList: ['Parts'],
    },
  },
  [RaceEnum.AISpectre]: {
    name: 'AI Spectre',
    count: NFT_COUNT_MAP,
    desc: 'AI can master the digital world, and they have the ability to control the "elements". AI will not die but can be "blocked". The weakness of AI is "data." They need to constantly consume data to grow, which is the main source for AI in the never-ending war.',
    img: {
      [LevelEnum.Legendary]:
        '/static/images/mintPage/icon/icons/race/Legendary/AISpectre.png',
      [LevelEnum.Magic]: '/static/images/mintPage/icon/icons/race/Magic/AISpectre.png',
      [LevelEnum.Common]:
        '/static/images/mintPage/icon/icons/race/PrimeEdition/AISpectre.png',
    },
    link: 'https://phala-nft-app.netlify.app/',
    bornData: {
      name: 'Databox',
      desc: 'AI Spectres exact beginning is not well known. They simply appear as a new entity but with limited bandwidth and a simple neural net. Fed sufficient data they begin to learn and enhance their own capacity exponentially.',
      img: '/static/images/detailPage/mintDetail/born-egg.png',
      foodList: ['Data'],
    },
  },
  [RaceEnum.XGene]: {
    name: 'X-Gene',
    count: NFT_COUNT_MAP,
    desc: 'AI tempted many human bioengineers to make biological modifications to high-potential creatures and replace humans. In the end, orangutans, bees, octopuses, raccoons, etc. came to the fore and successfully awakened intelligence.',
    img: {
      [LevelEnum.Legendary]:
        '/static/images/mintPage/icon/icons/race/Legendary/X-Gene.png',
      [LevelEnum.Magic]: '/static/images/mintPage/icon/icons/race/Magic/X-Gene.png',
      [LevelEnum.Common]:
        '/static/images/mintPage/icon/icons/race/PrimeEdition/X-Gene.png',
    },
    link: 'https://phala-nft-app.netlify.app/',
    bornData: {
      name: 'Mechanized DNA',
      desc: "X-Gene's start to take shape when a precise mix of nanotechnology comes into contact with suitable DNA. Given a sufficient supply of nanobots a startling sequence of gene modification, adaptation and evolution leads to a remarkable transformation.",
      img: '/static/images/detailPage/mintDetail/born-egg.png',
      foodList: ['Nanobots'],
    },
  },
}
